module.exports = __webpack_public_path__ + "static/img/sub03_2.727e023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/sub03_2.png
// module id = IPW2
// module chunks = 1